const MetricCell = ({
  value,
  max,
  format,
}: {
  value: number;
  max: number;
  format?: (v: number) => string;
}) => (
  <div className="text-right">
    <div>{format ? format(value) : value.toLocaleString()}</div>
    <div className="mt-0.4 h-0.4 bg-light-grey rounded-full overflow-hidden max-w-[8rem] ml-auto">
      <div
        className="h-full bg-magenta rounded-full"
        style={{ width: max > 0 ? `${(value / max) * 100}%` : '0%' }}
      />
    </div>
  </div>
);

export default MetricCell;
